import { createContext, useContext } from 'react';

export const DialogFullscreenContext = createContext(false);
/** Read whether the surrounding DialogContent is currently in full-screen mode. */
export const useDialogFullscreen = () => useContext(DialogFullscreenContext);
